<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listfiscalNature"
        :title-table="$t('Fiscal Nature')"
        module="fiscalNatureSettingsModule"
        sort-name="nome"
        add-permission="ROLE_NATUREZA_FISCAL_INSERIR"
        view-permission="ROLE_NATUREZA_FISCAL_CONSULTAR"
        edit-permission="ROLE_NATUREZA_FISCAL_ATUALIZAR"
        delete-permission="ROLE_NATUREZA_FISCAL_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormFiscalNature v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import FormFiscalNature from "./forms/FormFiscalNature.vue";

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormFiscalNature,
  },
  computed: {
    ...mapState("fiscalNatureSettingsModule", {
      listfiscalNature: (state) => state.listfiscalNature,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: "Id",
          field: "id",
        },
        {
          label: "Descrição",
          field: "nome",
        },
        {
          label: "Ativo",
          field: "ativo",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch(
        "fiscalNatureSettingsModule/prepareToEditFiscalNature",
        data,
      );
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
